import { createReducer } from '@reduxjs/toolkit';
import { getSimilarOperationIdsSuccess } from './jobs.actions';
import { IJobsState } from './jobs.interface';

const initState: IJobsState = {
  similarIds: [],
};

export const jobsReducer = createReducer(initState, (builder) =>
  builder.addCase(getSimilarOperationIdsSuccess, (state, action) => {
    state.similarIds = action.payload.data;
  }),
);
